import { inject, Injectable } from '@angular/core';
import { injectQuery } from '@tanstack/angular-query-experimental';
import { FinanceDashboardService } from '@core/services/finance-dashboard.service';
import { ApiResponse } from '@core/types';
import { FinanceDashboard, UnitAccountStatement } from '@core/types/finance.type';
import { QUERY_KEYS } from '@core/constans';
import { environment } from '@environments/environment';
import { lastValueFrom } from 'rxjs';
import { profileStore } from '@core/store';

@Injectable({ providedIn: 'root' })
export class FinanceDashboardQuery {
  private readonly dashboardService = inject(FinanceDashboardService);
  private readonly profileStore = inject(profileStore);

  useDashboard() {
    return injectQuery(() => {
      const condominiumId = this.profileStore.data.activeCondominiumId();
      return {
        queryKey: [...QUERY_KEYS.finance.dashboard(), condominiumId],
        queryFn: () => lastValueFrom(this.dashboardService.getDashboard()),
        select: (data: ApiResponse<FinanceDashboard>) => data.data,
        staleTime: environment.staleTime,
        enabled: !!condominiumId,
      };
    });
  }

  useUnitAccountStatement(unitId: () => string | null) {
    return injectQuery(() => {
      const id = unitId();
      return {
        queryKey: QUERY_KEYS.finance.unitStatement(id || ''),
        queryFn: () => lastValueFrom(this.dashboardService.getUnitAccountStatement(id!)),
        select: (data: ApiResponse<UnitAccountStatement>) => data.data,
        enabled: !!id,
      };
    });
  }
}
